/**
 * Copyright (c) 2019 Vendor Badge, LLC All Rights Reserved.
 * Created Date: Sunday, 17th February 2019
 *
 *  Portal - Login View: Login Form
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

// Material UI
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { Typography } from '@material-ui/core';

import EmailInput from 'components/InputFields/Email';
import PasswordInput from 'components/InputFields/Password';

class LoginForm extends React.Component {
  render() {
    const { classes } = this.props;

    const {
      email,
      password,
      showPasswordText,
      togglePasswordText,
      handleEmailChange,
      handlePasswordChange,
      signIn,
      isLoading,
    } = this.props.loginStore;

    const isInvalid = password === '' || email === '';

    return (
      <form autoComplete='on' action='' onSubmit={signIn}>
        <Grid container direction='column' justify='center' alignItems='center'>
          <Grid item xs={12}>
            <Grid item className={classes.formGridItem}>
              <Typography variant='h5' color='primary' className={classes.formTitle}>
                Welcome Back!
              </Typography>
            </Grid>
            <EmailInput
              id='email'
              autoComplete='on'
              disabled={isLoading}
              InputProps={{
                required: true,
                value: email,
                onChange: handleEmailChange,
                fullWidth: true,
                margin: 'dense',
                className: classes.formInput,
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <PasswordInput
              id='password'
              autoComplete='on'
              disabled={isLoading}
              showPasswordText={showPasswordText}
              showPasswordToggle={togglePasswordText}
              InputProps={{
                required: true,
                value: password,
                onChange: handlePasswordChange,
                fullWidth: true,
                margin: 'dense',
                className: classes.formInput,
              }}
            />
            <Grid item className={classes.resetLinkGrid}>
              <Typography variant='caption'>
                <Link to='/login/reset-password' className={classes.navLink}>
                  Forgot Password?
                </Link>
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid container justify='center' direction='column'>
          <Grid item xs={12} className={classes.buttonWrapper}>
            <Button
              variant='contained'
              disabled={isInvalid || isLoading}
              type='submit'
              color='primary'
              className={classes.formButton}
              style={{ width: '275px' }}
            >
              Sign In
            </Button>
            {isLoading && <CircularProgress size={24} className={classes.buttonProgress} />}
          </Grid>
          <Grid item>
            <Typography>Need an account?</Typography>
          </Grid>
          <Grid item>
            <Button color='primary' size='medium' variant='text' component={Link} to='/login/choose'>
              Sign Up
            </Button>
          </Grid>
        </Grid>
      </form>
    );
  }
}

LoginForm.propTypes = {
  classes: PropTypes.object.isRequired,
  showTitle: PropTypes.bool,
  showSignUp: PropTypes.bool,
};

const styles = theme => ({
  buttonWrapper: {
    position: 'relative',
  },
  formTitle: {
    marginBottom: '20px',
  },
  formInput: {
    minWidth: '265px',
    marginBottom: '8px',
    fontSize: '12pt',
  },
  iconButton: {
    color: theme.palette.type === 'light' ? 'rgb(128, 128, 128)' : theme.palette.common.white,
    padding: '0',
  },
  formButton: {
    marginTop: '25px',
    marginBottom: '15px',
    fontSize: '12pt',
  },
  buttonProgress: {
    zIndex: 1,
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -8,
    marginLeft: -15,
  },
  resetLinkGrid: {
    display: 'flex',
    textAlign: 'left',
  },
  navLink: {
    '&:link, &:visited': {
      textDecoration: 'none',
      color: theme.palette.text.primary,
    },
    '&:hover': {
      color: '#BD2025',
    },
    '&:active': {
      color: '#BD2025',
    },
  },
});

export default withStyles(styles, { withTheme: true })(inject('loginStore')(observer(LoginForm)));
